export const MODAL_LAYER_BASE = 1300;
export const MODAL_LAYER_STEP = 10;

/** Fixed z-index for all app dropdowns, menus, autocompletes, and date pickers. */
export const APP_DROPDOWN_Z_INDEX = 1400;

/** Minimum z-index for platform connection backdrops (above dropdowns). */
export const CONNECTION_BACKDROP_Z_INDEX = APP_DROPDOWN_Z_INDEX + 100;

/** @type {{ id: string, zIndex: number }[]} */
let openModalLayers = [];

export const registerModalLayer = (modalId, explicitZIndex) => {
  const existing = openModalLayers.find((layer) => layer.id === modalId);
  if (existing) {
    if (explicitZIndex != null) {
      existing.zIndex = explicitZIndex;
    }
    return existing.zIndex;
  }

  const stackedZIndex =
    MODAL_LAYER_BASE + openModalLayers.length * MODAL_LAYER_STEP;
  const zIndex = explicitZIndex ?? stackedZIndex;
  openModalLayers.push({ id: modalId, zIndex });
  return zIndex;
};

export const unregisterModalLayer = (modalId) => {
  openModalLayers = openModalLayers.filter((layer) => layer.id !== modalId);
};

export const getMaxModalLayerZIndex = () => {
  if (openModalLayers.length === 0) {
    return 0;
  }

  return Math.max(...openModalLayers.map((layer) => layer.zIndex));
};

/** z-index for connection backdrops: always above the topmost open modal layer. */
export const getConnectionBackdropZIndex = () => {
  const topModalZIndex = getMaxModalLayerZIndex();
  const dynamicZIndex =
    topModalZIndex > 0
      ? topModalZIndex + MODAL_LAYER_STEP
      : CONNECTION_BACKDROP_Z_INDEX;

  return Math.max(dynamicZIndex, CONNECTION_BACKDROP_Z_INDEX);
};

/** Minimum z-index for Google Picker (above gallery, dropdowns, and connection backdrops). */
export const GOOGLE_PICKER_Z_INDEX_MIN =
  CONNECTION_BACKDROP_Z_INDEX + MODAL_LAYER_STEP;

/** z-index for Google Picker: always above the topmost open modal layer. */
export const getGooglePickerZIndex = () => {
  const topModalZIndex = getMaxModalLayerZIndex();
  const stackedAboveModal =
    topModalZIndex > 0
      ? topModalZIndex + MODAL_LAYER_STEP
      : MODAL_LAYER_BASE + MODAL_LAYER_STEP;

  return Math.max(stackedAboveModal, GOOGLE_PICKER_Z_INDEX_MIN);
};
